import { render, staticRenderFns } from "./BaseActiveAccountButton.vue?vue&type=template&id=1727c88a&scoped=true"
import script from "./BaseActiveAccountButton.vue?vue&type=script&lang=js"
export * from "./BaseActiveAccountButton.vue?vue&type=script&lang=js"
import style0 from "./BaseActiveAccountButton.vue?vue&type=style&index=0&id=1727c88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727c88a",
  null
  
)

export default component.exports